(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["alygn-upsells"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__alygnUpsellInit) return;
    window.__alygnUpsellInit = true;

    var HORIZON_TIMEOUT = 1500;
    var MODAL = '[data-upsell-modal]';

    var lastFocus = null;
    var savedScrollY = 0;

    function currentScrollY() {
      return window.scrollY || document.documentElement.scrollTop || 0;
    }

    function prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    /* Galerij */

    function getGallery(modal) {
      var track = modal ? modal.querySelector('[data-upsell-track]') : null;
      if (!track) return null;
      return {
        track: track,
        slides: track.querySelectorAll('[data-upsell-slide]'),
        thumbs: modal.querySelectorAll('[data-upsell-thumb]'),
        thumbRow: modal.querySelector('[data-upsell-thumbs]'),
        prev: modal.querySelector('[data-upsell-prev]'),
        next: modal.querySelector('[data-upsell-next]'),
        counter: modal.querySelector('[data-upsell-counter]')
      };
    }

    function clampIndex(g, index) {
      var max = g.slides.length - 1;
      if (isNaN(index)) index = 0;
      return Math.max(0, Math.min(index, max));
    }

    // Zet miniatuur, pijltjes en teller op de juiste foto, zonder de strook te scrollen.
    function markImage(modal, index) {
      var g = getGallery(modal);
      if (!g || !g.slides.length) return;
      index = clampIndex(g, index);
      modal.dataset.imageIndex = String(index);

      g.thumbs.forEach(function (t, i) {
        var on = i === index;
        t.classList.toggle('is-selected', on);
        t.setAttribute('aria-current', on ? 'true' : 'false');
      });

      if (g.prev) g.prev.disabled = index === 0;
      if (g.next) g.next.disabled = index >= g.slides.length - 1;
      if (g.counter) g.counter.textContent = (index + 1) + ' / ' + g.slides.length;

      // Houd de actieve miniatuur in beeld als de rij breder is dan het scherm.
      var active = g.thumbs[index];
      if (active && g.thumbRow && g.thumbRow.scrollWidth > g.thumbRow.clientWidth) {
        var left = active.offsetLeft - (g.thumbRow.clientWidth - active.offsetWidth) / 2;
        g.thumbRow.scrollTo({ left: Math.max(0, left), behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
      }
    }

    function goToImage(modal, index, instant) {
      var g = getGallery(modal);
      if (!g || !g.slides.length) return;
      index = clampIndex(g, index);
      var slide = g.slides[index];
      g.track.scrollTo({
        left: slide.offsetLeft,
        behavior: (instant || prefersReducedMotion()) ? 'auto' : 'smooth'
      });
      markImage(modal, index);
    }

    // Na swipen of scrollen de miniaturen bijwerken. Pas uitvoeren als het
    // scrollen stilstaat, anders knipperen de miniaturen mee tijdens een
    // animatie van foto 1 naar foto 4.
    function bindGallery(modal) {
      var g = getGallery(modal);
      if (!g || g.track.dataset.bound) return;
      g.track.dataset.bound = '1';

      var timer = null;
      g.track.addEventListener('scroll', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          var w = g.track.clientWidth || 1;
          var idx = Math.round(g.track.scrollLeft / w);
          if (String(idx) !== modal.dataset.imageIndex) markImage(modal, idx);
        }, 90);
      }, { passive: true });
    }

    /* Pop up */

    function openModal(id) {
      var m = document.querySelector('[data-upsell-modal="' + id + '"]');
      if (!m) return;

      lastFocus = document.activeElement;
      savedScrollY = currentScrollY();

      m.hidden = false;
      document.documentElement.style.overflow = 'hidden';

      // Foto's in een verborgen pop up laden lui. Nu hij open is, alles direct laden
      // zodat swipen niet op lege vlakken uitkomt.
      m.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });

      bindGallery(m);
      goToImage(m, 0, true);

      var c = m.querySelector('[data-upsell-close]');
      if (c) c.focus({ preventScroll: true });
    }

    function closeModal(m, opts) {
      if (!m || m.hidden) return;

      m.hidden = true;
      document.documentElement.style.overflow = '';

      var focusBack = !(opts && opts.skipFocus);
      if (focusBack && lastFocus && typeof lastFocus.focus === 'function') {
        try { lastFocus.focus({ preventScroll: true }); } catch (err) {}
      }
      lastFocus = null;

      var target = savedScrollY;
      requestAnimationFrame(function () {
        if (Math.abs(currentScrollY() - target) > 2) window.scrollTo(0, target);
      });
    }

    function openModalEl() {
      return document.querySelector(MODAL + ':not([hidden])');
    }

    /* Winkelwagen */

    function setLabel(label, text) {
      if (label) label.textContent = text;
    }

    function resetAddButton(add, label, defaultText) {
      add.classList.remove('is-loading', 'is-added', 'is-error');
      setLabel(label, defaultText);
    }

    function getCartCount() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { return typeof c.item_count === 'number' ? c.item_count : null; })
        .catch(function () { return null; });
    }

    function waitForCartAdd(before, timeout) {
      return new Promise(function (resolve) {
        var done = false;
        var timer = null;
        var events = ['cart:update', 'cart:refresh', 'cart:added'];

        function finish(ok) {
          if (done) return;
          done = true;
          events.forEach(function (n) { document.removeEventListener(n, onEvt); });
          if (timer) clearTimeout(timer);
          resolve(ok);
        }
        function onEvt() { finish(true); }

        events.forEach(function (n) { document.addEventListener(n, onEvt); });

        timer = setTimeout(function () {
          if (before === null) {
            console.warn('[alygn upsell] Winkelwagen niet te vergelijken, fallback overgeslagen.');
            finish(true);
            return;
          }
          getCartCount().then(function (after) {
            finish(after !== null && after > before);
          });
        }, timeout);
      });
    }

    function directAdd(id) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
      }).then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data && data.description ? data.description : 'Toevoegen mislukt');
          return data;
        });
      }).then(function (data) {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        return data;
      });
    }

    /* Klikken */

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-upsell-open]');
      if (opener) { openModal(opener.getAttribute('data-upsell-open')); return; }

      var closer = e.target.closest('[data-upsell-close]');
      if (closer) { closeModal(closer.closest(MODAL)); return; }

      if (e.target.matches(MODAL)) { closeModal(e.target); return; }

      var thumb = e.target.closest('[data-upsell-thumb]');
      if (thumb) {
        goToImage(thumb.closest(MODAL), parseInt(thumb.getAttribute('data-upsell-thumb'), 10));
        return;
      }

      var nav = e.target.closest('[data-upsell-prev], [data-upsell-next]');
      if (nav) {
        var mn = nav.closest(MODAL);
        var cur = parseInt(mn.dataset.imageIndex || '0', 10);
        goToImage(mn, cur + (nav.hasAttribute('data-upsell-next') ? 1 : -1));
        return;
      }

      var vbtn = e.target.closest('[data-upsell-variant]');
      if (vbtn) {
        var modal = vbtn.closest(MODAL);
        modal.querySelectorAll('[data-upsell-variant]').forEach(function (b) {
          b.classList.remove('is-selected');
          b.setAttribute('aria-pressed', 'false');
        });
        vbtn.classList.add('is-selected');
        vbtn.setAttribute('aria-pressed', 'true');
        modal.dataset.selected = vbtn.getAttribute('data-variant-id');

        var priceEl = modal.querySelector('[data-upsell-price]');
        if (priceEl) priceEl.textContent = vbtn.getAttribute('data-price');

        var cmpEl = modal.querySelector('[data-upsell-compare]');
        var cmp = vbtn.getAttribute('data-compare');
        if (cmpEl) {
          cmpEl.textContent = cmp || '';
          cmpEl.style.display = cmp ? '' : 'none';
        }

        var discEl = modal.querySelector('[data-upsell-disc]');
        var d = vbtn.getAttribute('data-disc');
        if (discEl) {
          var valueEl = discEl.querySelector('[data-upsell-disc-value]');
          if (valueEl && d) valueEl.textContent = (discEl.getAttribute('data-save-label') || 'Bespaar') + ' ' + d + '%';
          discEl.style.display = d ? '' : 'none';
        }

        var addBtn = modal.querySelector('[data-upsell-add]');
        if (addBtn) addBtn.disabled = vbtn.getAttribute('data-available') !== 'true';

        // Heeft de variant een eigen foto, dan springt de galerij daarheen.
        var imgIdx = vbtn.getAttribute('data-image-index');
        if (imgIdx !== null && imgIdx !== '') goToImage(modal, parseInt(imgIdx, 10));
        return;
      }

      var add = e.target.closest('[data-upsell-add]');
      if (!add) return;
      if (add.classList.contains('is-loading') || add.disabled) return;

      var modal2 = add.closest(MODAL);
      var item = add.closest('[data-upsell-item]');
      var wrap = add.closest('.alygn-upsells');
      var id = modal2 ? modal2.dataset.selected : null;
      if (!id) return;

      var label = add.querySelector('[data-upsell-add-label]');
      var busyText = (wrap && wrap.dataset.busyLabel) || 'Bezig';
      var addedText = (wrap && wrap.dataset.addedLabel) || 'Toegevoegd';
      var errorText = (wrap && wrap.dataset.errorLabel) || 'Niet gelukt, probeer opnieuw';

      var defaultText = add.getAttribute('data-default-label');
      if (defaultText === null) {
        defaultText = label ? label.textContent : 'In winkelwagen';
        add.setAttribute('data-default-label', defaultText);
      }

      var pform = item ? item.querySelector('[data-upsell-form]') : null;
      var form = pform ? pform.querySelector('form') : null;
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      var submitBtn = form ? form.querySelector('[data-upsell-submit]') : null;

      add.classList.remove('is-added', 'is-error');
      add.classList.add('is-loading');
      setLabel(label, busyText);

      getCartCount().then(function (before) {
        if (form && idInput && submitBtn) {
          idInput.value = id;
          // Echte click, zodat Horizon handleClick en handleSubmit allebei draait.
          submitBtn.click();

          return waitForCartAdd(before, HORIZON_TIMEOUT).then(function (ok) {
            if (ok) return true;
            console.warn('[alygn upsell] Horizon form reageerde niet, fallback naar /cart/add.js');
            return directAdd(id).then(function () { return true; });
          });
        }
        return directAdd(id).then(function () { return true; });
      }).then(function () {
        add.classList.remove('is-loading');
        add.classList.add('is-added');
        setLabel(label, addedText);
        setTimeout(function () {
          if (modal2) closeModal(modal2, { skipFocus: true });
          resetAddButton(add, label, defaultText);
        }, 400);
      }).catch(function (err) {
        add.classList.remove('is-loading');
        add.classList.add('is-error');
        setLabel(label, (err && err.message) ? err.message : errorText);
        setTimeout(function () { resetAddButton(add, label, defaultText); }, 4000);
      });
    });

    /* Toetsenbord en schermgrootte */

    document.addEventListener('keydown', function (e) {
      var open = openModalEl();
      if (!open) return;

      if (e.key === 'Escape') { closeModal(open); return; }

      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
        var tag = (e.target && e.target.tagName) || '';
        if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;
        e.preventDefault();
        var cur = parseInt(open.dataset.imageIndex || '0', 10);
        goToImage(open, cur + (e.key === 'ArrowRight' ? 1 : -1));
      }
    });

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var open = openModalEl();
        if (open) goToImage(open, parseInt(open.dataset.imageIndex || '0', 10), true);
      }, 120);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["alygn-volume-pricing"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('alygn-volume-pricing')) {
    class AlygnVolumePricing extends HTMLElement {
      connectedCallback() {
        this.price = Number(this.dataset.price) || 0;
        this.vat = Number(this.dataset.vat) || 0;
        this.variantId = this.dataset.variantId;
        this.productId = this.dataset.productId;
        this.available = this.dataset.available === 'true';
        try {
          this.tiers = JSON.parse(this.dataset.tiers || '[]').sort((a, b) => a.min - b.min);
        } catch (e) {
          this.tiers = [];
        }
        try {
          this.fmt = new Intl.NumberFormat(this.dataset.locale || 'nl', { style: 'currency', currency: this.dataset.currency || 'EUR' });
        } catch (e) {
          this.fmt = new Intl.NumberFormat('nl', { style: 'currency', currency: 'EUR' });
        }

        this.qtyInput = this.querySelector('[data-qty]');
        this.button = this.querySelector('[data-atc]');
        this.buttonLabel = this.querySelector('[data-atc-label]');
        this.status = this.querySelector('[data-status]');
        this.dialog = this.querySelector('dialog');

        this.onClick = this.onClick.bind(this);
        this.onVariant = this.onVariant.bind(this);
        this.addEventListener('click', this.onClick);
        document.addEventListener('variant:update', this.onVariant);

        this.qtyInput.addEventListener('input', () => this.render());
        this.qtyInput.addEventListener('change', () => {
          this.qtyInput.value = this.qty;
          this.render();
        });

        if (this.dialog) {
          this.dialog.addEventListener('click', (e) => {
            if (e.target === this.dialog) this.dialog.close();
          });
        }

        // Na versturen van het contactformulier de dialoog weer tonen met de melding
        if (this.querySelector('[data-reopen]')) {
          const details = this.querySelector('details');
          if (details) details.open = true;
          requestAnimationFrame(() => this.openDialog());
        }

        this.render();
      }

      disconnectedCallback() {
        document.removeEventListener('variant:update', this.onVariant);
      }

      get qty() {
        const n = parseInt(this.qtyInput.value, 10);
        return Number.isFinite(n) && n > 0 ? Math.min(n, 9999) : 1;
      }

      tierFor(q) {
        let found = null;
        for (const tier of this.tiers) if (q >= tier.min) found = tier;
        return found;
      }

      money(cents) {
        return this.fmt.format(cents / 100);
      }

      onVariant(event) {
        const detail = event.detail || {};
        const variant = detail.resource;
        if (!variant || !variant.id) return;
        const pid = detail.data && detail.data.productId;
        if (pid && String(pid) !== String(this.productId) && !(detail.data && detail.data.newProduct)) return;

        this.variantId = String(variant.id);
        this.price = Number(variant.price) || this.price;
        this.available = variant.available !== false;

        const productField = this.querySelector('[data-form-product]');
        if (productField && variant.name) productField.value = variant.name;

        this.render();
      }

      render() {
        const q = this.qty;
        const tier = this.tierFor(q);
        const pct = tier ? tier.pct : 0;

        this.querySelectorAll('[data-tier-price]').forEach((el) => {
          const p = Number(el.dataset.pct) || 0;
          el.textContent = this.money(Math.round((this.price * (100 - p)) / (100 + this.vat)));
        });
        this.querySelectorAll('[data-tier-col]').forEach((el) => {
          el.classList.toggle('is-active', !!tier && Number(el.dataset.min) === tier.min);
        });

        const totalIncl = Math.round((this.price * q * (100 - pct)) / 100);
        const totalExcl = Math.round((this.price * q * (100 - pct)) / (100 + this.vat));
        const unit = q === 1 ? this.dataset.unitSingular : this.dataset.unitPlural;

        const note = this.querySelector('[data-total-note]');
        if (note) note.textContent = `Totaal voor ${q} ${unit}${pct ? `, ${pct}% korting` : ''}, excl. btw`;
        const excl = this.querySelector('[data-total-excl]');
        if (excl) excl.textContent = this.money(totalExcl);
        const incl = this.querySelector('[data-total-incl]');
        if (incl) incl.textContent = this.money(totalIncl);

        if (!this.busy) {
          this.button.disabled = !this.available;
          this.setLabel(this.available ? this.dataset.labelDefault : this.dataset.labelSoldout);
        }
      }

      setLabel(text) {
        if (this.buttonLabel) this.buttonLabel.textContent = text;
      }

      onClick(event) {
        const step = event.target.closest('[data-step]');
        if (step) {
          this.qtyInput.value = Math.max(1, this.qty + Number(step.dataset.step));
          this.render();
          return;
        }
        if (event.target.closest('[data-atc]')) {
          event.preventDefault();
          this.addToCart();
          return;
        }
        if (event.target.closest('[data-open-form]')) {
          event.preventDefault();
          this.openDialog();
          return;
        }
        if (event.target.closest('[data-close-form]') && this.dialog) {
          this.dialog.close();
        }
      }

      openDialog() {
        if (!this.dialog || this.dialog.open) return;
        const qtyField = this.querySelector('[data-form-qty]');
        if (qtyField && !qtyField.value) qtyField.value = this.qty;
        this.dialog.showModal();
      }

      async addToCart() {
        if (this.busy || !this.available) return;
        this.busy = true;
        this.button.setAttribute('aria-busy', 'true');
        this.setLabel(this.dataset.labelAdding);
        this.status.textContent = '';

        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

        try {
          const res = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(this.variantId), quantity: this.qty }] }),
          });
          const data = await res.json();
          if (!res.ok) throw new Error(data.description || data.message || this.dataset.labelError);

          const cart = await fetch(`${root}cart.js`).then((r) => r.json());
          await this.announce(cart);

          this.setLabel(this.dataset.labelAdded);
          setTimeout(() => this.render(), 1800);
        } catch (err) {
          this.status.textContent = (err && err.message) || this.dataset.labelError;
          this.setLabel(this.dataset.labelDefault);
        } finally {
          this.busy = false;
          this.button.removeAttribute('aria-busy');
        }
      }

      async announce(cart) {
        const data = {
          source: 'alygn-volume-pricing',
          itemCount: cart.item_count,
          productId: this.productId,
          variantId: this.variantId,
          didError: false,
        };

        // Horizon eigen event gebruiken zodat teller en cart drawer meebewegen
        let evt = null;
        try {
          const events = await import('@theme/events');
          if (events && events.CartAddEvent) evt = new events.CartAddEvent({}, 'alygn-volume-pricing', data);
        } catch (e) {}
        if (!evt) {
          evt = new CustomEvent('cart:update', { bubbles: true, detail: { resource: {}, sourceId: 'alygn-volume-pricing', data } });
        }
        this.dispatchEvent(evt);

        const drawer = document.querySelector('cart-drawer-component');
        if (!drawer) {
          window.location.href = this.dataset.cartUrl || '/cart';
          return;
        }
        setTimeout(() => {
          const dlg = drawer.querySelector('dialog');
          if (dlg && !dlg.open && typeof drawer.open === 'function') {
            try { drawer.open(); } catch (e) {}
          }
        }, 150);
      }
    }

    customElements.define('alygn-volume-pricing', AlygnVolumePricing);
  }
  } catch(e) { console.error(e); }
})();

})();
